export const gitCommit = '0062dad7'
